import React from "react";
import styled from "styled-components";
import { Entry } from "contentful";

interface PLPCTARowProps extends Entry {
  id: string;
  brand: string;
  fields: {
    ctas?: { fields: { label: string; url: string } }[];
  };
}

const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 20px 0;
  gap: 15px;
  width: calc(100% + 16px);
  margin-left: 0;
  margin-right: -16px;
  box-sizing: border-box;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;

  /* Hide scrollbar */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const CustomCTA = styled.a<{ $isActive: boolean }>`
  background-color: white;
  border: ${(props) => (props.$isActive ? "1px solid black" : "1px solid transparent")};
  color: black;
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  border-radius: 30px;
  margin-right: 5px;
  font-family: "Instrument Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.02em;
  font-size: 13px;
  text-decoration: none;

  &:hover {
    background: white;
    border: 1px solid black;
  }
`;

const PLPCTARow: React.FC<PLPCTARowProps> = ({ fields: { ctas } }) => {
  const currentPath = window.location.pathname;

  return (
    <ScrollContainer>
      {ctas?.map((cta, index) => {
        const isActive = currentPath === cta.fields.url;
        return (
          <CustomCTA key={index} href={cta.fields.url} $isActive={isActive}>
            {cta.fields.label}
          </CustomCTA>
        );
      })}
    </ScrollContainer>
  );
};

export default PLPCTARow;